import request from '@/utils/request'

export function getFinishedInfo (data) {
  return request({
    url: '/record/DesignTask/getFinishedInfo',
    method: 'post',
    data
  })
}
//出差申请
export function travalapply(data,action) {
  return request({
    url: "/record/travalapply/"+action,
    method: "post",
    data
  });
}
export function audit(data) {
  return request({
    url: '/record/oatask/audit',
    method: 'post',
    data
  })
}
export function oataskAdd(data) {
  return request({
    url: '/record/oatask/add',
    method: 'post',
    data
  })
}
export function oataskEdit(data) {
  return request({
    url: '/record/oatask/edit',
    method: 'post',
    data
  })
}
export function oataskList (data) {
  return request({
    url: '/record/oatask/index',
    method: 'post',
    data
  })
}

export function oataskDel (data) {
  return request({
    url: '/record/oatask/del',
    method: 'post',
    data
  })
}

export function noticeRead (data) {
  return request({
    url: '/record/notice/noticeRead',
    method: 'post',
    data
  })
}
export function noticeByQuery (data) {
  return request({
    url: '/record/notice/list',
    method: 'post',
    data
  })
}

export function noticeEdit (data) {
  return request({
    url: '/record/notice/edit',
    method: 'post',
    data
  })
}

export function noticeDelete (data) {
  return request({
    url: '/record/notice/delete',
    method: 'post',
    data
  })
}

// 工作失误 list
export function issuesByQuery (data) {
  return request({
    url: '/record/issues/list',
    method: 'post',
    data
  })
}

// 工作失误 edit
export function issuesEdit (data) {
  return request({
    url: '/record/issues/edit',
    method: 'post',
    data
  })
}

// 工作失误 delete
export function issuesDelete (data) {
  return request({
    url: '/record/issues/delete',
    method: 'post',
    data
  })
}

// updateDoeTime
export function updateDoeTime (data) {
  return request({
    url: '/record/doe/updateDoeTime',
    method: 'post',
    data
  })
}
// ECE list
export function cecByQuery (data) {
  return request({
    url: '/record/cec',
    method: 'post',
    data
  })
}

// cec edit
export function cecEdit (data) {
  return request({
    url: '/record/cec/edit/ids/' + data.id,
    method: 'post',
    data: data.data
  })
}

// cec add
export function cecAdd (data) {
  return request({
    url: '/record/cec/add',
    method: 'post',
    data
  })
}

// cec delete
export function cecDelete (data) {
  return request({
    url: '/record/cec/del',
    method: 'post',
    data
  })
}

// DOE list
export function doeByQuery (data) {
  return request({
    url: '/record/doe',
    method: 'post',
    data
  })
}

// DOE edit
export function doeEdit (data) {
  return request({
    url: '/record/doe/edit/ids/' + data.id,
    method: 'post',
    data: data.data
  })
}

// DOE add
export function doeAdd (data) {
  return request({
    url: '/record/doe/add',
    method: 'post',
    data
  })
}

// DOE delete
export function doeDelete (data) {
  return request({
    url: '/record/doe/del',
    method: 'post',
    data
  })
}



// 水龙头专利导入
export function importSlt (data) {
  return request({
    url: '/record/copyright/importSlt',
    method: 'post',
    data:data
  })
}
// 本地图片需要购买
export function needBuyCert (data) {
  return request({
    url: '/record/cert/needBuyCert',
    method: 'post',
    data:data
  })
}
// 本地图片不参与授权筛选
export function denyLocalImage (data) {
  return request({
    url: '/record/cert/denyLocalImage',
    method: 'post',
    data:data
  })
}
// 授权主体DEL
export function delBrandCompany (data) {
  return request({
    url: '/record/cert/delBrandCompany',
    method: 'post',
    data:data
  })
}
// 授权主体
export function addBrandCompany (data) {
  return request({
    url: '/record/cert/addBrandCompany',
    method: 'post',
    data:data
  })
}
// 授权主体
export function companyByQuery (data) {
  return request({
    url: '/record/cert/companyByQuery',
    method: 'post',
    data
  })
}
export function getNewPhotoNotFinishedInfo (data) {
  return request({
    url: '/record/selection/getNewPhotoNotFinishedInfo',
    method: 'post',
    data
  })
}
// 授权 list--商品弹框显示
export function importFzpSelection (data) {
  return request({
    url: '/record/selection/importFzpSelection',
    method: 'post',
    data
  })
}
// 授权 list--商品弹框显示
export function getCertList (data) {
  return request({
    url: '/record/cert/getCertList',
    method: 'post',
    data
  })
}
// 授权 list
export function certByQuery (data) {
  return request({
    url: '/record/cert',
    method: 'post',
    data
  })
}

// 授权 edit
export function certEdit (data) {
  return request({
    url: '/record/cert/edit/ids/' + data.id,
    method: 'post',
    data: data.data
  })
}

// 授权 add
export function certAdd (data) {
  return request({
    url: '/record/cert/add',
    method: 'post',
    data
  })
}

// 授权 delete
export function certDelete (data) {
  return request({
    url: '/record/cert/del',
    method: 'post',
    data
  })
}


// 选品 -list
export function getCommonData(data) {
  return request({
    url: "/record/Selectionslt/getCommonData",
    method: "post",
    data
  });
}
// 选品 -list
export function updateCommonData(data) {
  return request({
    url: "/record/Selectionslt/updateCommonData",
    method: "post",
    data
  });
}
// 选品 -list
export function listSelectionslt(data) {
  return request({
    url: "/record/Selectionslt/",
    method: "post",
    data
  });
}
// 选品 add
export function addSelectionslt(data) {
  return request({
    url: "/record/Selectionslt/add",
    method: "post",
    data
  });
}
// 选品 edit
export function editSelectionslt(data) {
  return request({
    url: "/record/Selectionslt/edit/",
    method: "post",
    data
  });
}
// productupdate list
export function productupdateList (data) {
  return request({
    url: '/record/Producttip/',
    method: 'post',
    data
  })
}

// productupdate add
export function productupdateAdd(data) {
  return request({
    url: '/record/Producttip/add',
    method: 'post',
    data: data
  })
}

// productupdate edit
export function productupdateEdit(id,data) {
  return request({
    url: '/record/Producttip/edit/ids/'+id,
    method: 'post',
    data: data
  })
}

// productupdate del
export function productupdateDel(data) {
  return request({
    url: '/record/Producttip/del/',
    method: 'post',
    data: data
  })
}

export function checkAsin(data) {
  return request({
    url: "/record/Selection/checkAsin",
    method: "post",
    data
  });
}
// 抄袭 -list
export function listSteal(data) {
  return request({
    url: "/record/Steal/",
    method: "post",
    data
  });
}
// 抄袭 add
export function addSteal(data) {
  return request({
    url: "/record/Steal/add",
    method: "post",
    data
  });
}
// 抄袭 edit
export function editSteal(data) {
  return request({
    url: "/record/Steal/edit/",
    method: "post",
    data
  });
}


// 纺织品选品删除
export function delSelection (data) {
  return request({
    url: '/record/selection/del',
    method: 'post',
    data:data
  })
}
// 选品 -editRelation
export function editRelation(data) {
  return request({
    url: "/record/Selection/editRelation",
    method: "post",
    data
  });
}
// 选品 -addProduct
export function addProduct(data) {
  return request({
    url: "/record/Selection/addProduct",
    method: "post",
    data
  });
}
// 选品 -透视
export function sumSelection(data) {
  return request({
    url: "/record/Selection/sumSelection",
    method: "post",
    data
  });
}
export function waitSelection(data) {
  return request({
    url: "/record/Selection/waitSelection",
    method: "post",
    data
  });
}
// 选品 -list
export function listSelection(data) {
  return request({
    url: "/record/Selection/",
    method: "post",
    data
  });
}
// 选品 add
export function addSelection(data) {
  return request({
    url: "/record/Selection/add",
    method: "post",
    data
  });
}
// 选品 edit
export function editSelection(data) {
  return request({
    url: "/record/Selection/edit/",
    method: "post",
    data
  });
}
export function delTaskDetail(data) {
  return request({
    url: "/record/DesignTask/delTaskDetail",
    method: "post",
    data
  });
}
export function listTaskDetail(data) {
  return request({
    url: "/record/DesignTask/listTaskDetail",
    method: "post",
    data
  });
}
export function importTaskDetail(data) {
  return request({
    url: "/record/DesignTask/importTaskDetail",
    method: "post",
    data
  });
}
export function getAsin(data) {
  return request({
    url: "/record/DesignTask/getAsin",
    method: "post",
    data
  });
}
// 美工任务 -list
export function listDesignTask(data) {
  return request({
    url: "/record/DesignTask/",
    method: "post",
    data
  });
}
// 美工任务 add
export function addDesignTask(data) {
  return request({
    url: "/record/DesignTask/add",
    method: "post",
    data
  });
}
// 美工任务 edit
export function editDesignTask(data) {
  return request({
    url: "/record/DesignTask/edit/ids/"+data.id,
    method: "post",
    data:data.data
  });
}
// 美工任务 del
export function delDesignTask(data) {
  return request({
    url: "/record/DesignTask/del",
    method: "post",
    data
  });
}

// deal list
export function dealList (data) {
  return request({
    url: '/record/Deal/list',
    method: 'post',
    data
  })
}

// deal edit
export function dealEdit(data) {
  return request({
    url: '/record/Deal/edit',
    method: 'post',
    data: data
  })
}


// 账单 list
export function billByQuery (data) {
  return request({
    url: '/record/bill',
    method: 'post',
    data
  })
}

// 账单 edit
export function billEdit (data) {
  return request({
    url: '/record/bill/edit/ids/' + data.id,
    method: 'post',
    data: data.data
  })
}

// 账单 add
export function billAdd (data) {
  return request({
    url: '/record/bill/add',
    method: 'post',
    data
  })
}

// 账单 delete
export function billDelete (data) {
  return request({
    url: '/record/bill/del',
    method: 'post',
    data
  })
}

// 版权 list
export function copyrightByQuery (data) {
  return request({
    url: '/record/copyright',
    method: 'post',
    data
  })
}

// 版权 edit
export function copyrightEdit (data) {
  return request({
    url: '/record/copyright/edit/ids/' + data.id,
    method: 'post',
    data: data.data
  })
}

// 版权 add
export function copyrightAdd (data) {
  return request({
    url: '/record/copyright/add',
    method: 'post',
    data
  })
}

// 版权 delete
export function copyrightDelete (data) {
  return request({
    url: '/record/copyright/del',
    method: 'post',
    data
  })
}

// 报关 list
export function invoiceByQuery (data) {
  return request({
    url: '/record/invoice',
    method: 'post',
    data
  })
}

// 报关 edit
export function invoiceEdit (data) {
  return request({
    url: '/record/invoice/edit/ids/' + data.id,
    method: 'post',
    data: data.data
  })
}

// 报关 add
export function invoiceAdd (data) {
  return request({
    url: '/record/invoice/add',
    method: 'post',
    data
  })
}

// 报关 delete
export function invoiceDelete (data) {
  return request({
    url: '/record/invoice/del',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/record.js